import { render, staticRenderFns } from "./ReminderSend.vue?vue&type=template&id=29362aed"
import script from "./ReminderSend.vue?vue&type=script&lang=ts"
export * from "./ReminderSend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29362aed')) {
      api.createRecord('29362aed', component.options)
    } else {
      api.reload('29362aed', component.options)
    }
    module.hot.accept("./ReminderSend.vue?vue&type=template&id=29362aed", function () {
      api.rerender('29362aed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/ReminderSend.vue"
export default component.exports